'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SliderArrow = require('./SliderArrow.scss');

var _SliderArrow2 = _interopRequireDefault(_SliderArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderArrow = function (_PureComponent) {
    (0, _inherits3.default)(SliderArrow, _PureComponent);

    function SliderArrow() {
        (0, _classCallCheck3.default)(this, SliderArrow);
        return (0, _possibleConstructorReturn3.default)(this, (SliderArrow.__proto__ || (0, _getPrototypeOf2.default)(SliderArrow)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderArrow, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                next = _props.next,
                onClick = _props.onClick,
                prev = _props.prev,
                style = _props.style;

            var icon = prev ? ['fas', 'caret-left'] : ['fas', 'caret-right'];
            var classes = '' + (next ? _SliderArrow2.default.next : _SliderArrow2.default.prev) + (className ? ' ' + className : '');
            return (0, _jsx3.default)('div', {
                className: classes,
                style: (0, _extends3.default)({}, style),
                onClick: onClick
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: icon,
                className: _SliderArrow2.default.arrow
            }));
        }
    }]);
    return SliderArrow;
}(_react.PureComponent);

exports.default = SliderArrow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SliderArrow/SliderArrow.js
// module id = Kn4k
// module chunks = 57